import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  const navLinks = [
    { id: 'hero', label: 'トップ' },
    { id: 'catalog', label: '買取品目' },
    { id: 'benefit', label: '選ばれる理由' },
    { id: 'flow', label: 'ご利用の流れ' },
    { id: 'faq', label: 'よくある質問' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-[#00A58E] shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <button
            onClick={() => scrollToSection('hero')}
            className="flex items-center gap-3 cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/bac9cc4b08f51c73312a598e4205cf6d.png"
              alt="飛翠ロゴ"
              className={`h-10 w-auto transition-all duration-300 ${
                isScrolled ? 'brightness-0 invert' : 'brightness-0 invert'
              }`}
            />
          </button>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className={`font-medium transition-colors whitespace-nowrap ${
                  isScrolled
                    ? 'text-white hover:text-[#FFD700]'
                    : 'text-white hover:text-[#FFD700]'
                }`}
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('cta')}
              className="px-6 py-2.5 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white font-bold rounded-full hover:scale-105 transition-transform shadow-lg whitespace-nowrap"
            >
              無料査定を申し込む
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-white"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-3 border-t border-white/20 pt-4">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="block w-full text-left text-white font-medium py-2 hover:text-[#FFD700] transition-colors"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('cta')}
              className="w-full px-6 py-3 bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white font-bold rounded-full hover:scale-105 transition-transform shadow-lg whitespace-nowrap"
            >
              無料査定を申し込む
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}